import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { UserPlus, Mail, Lock, User, Building } from 'lucide-react';

const RegistrationStep = ({ assessmentId, assessmentData }) => {
  const [form, setForm] = useState({
    email: assessmentData?.company_info?.contact_email || '', password: '',
    full_name: '', company_name: assessmentData?.company_info?.company_name || '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { setError('Password must be at least 6 characters'); return; }
    setError(''); setLoading(true);
    try {
      const res = await api.registerAfterAssessment(assessmentId, form);
      api.setAuth(res.access_token, res.user);
      navigate('/dashboard');
    } catch (err) { setError(err.message || 'Registration failed'); }
    setLoading(false);
  };

  const inputCls = "w-full bg-white border border-gray-300 rounded-lg pl-10 pr-4 py-3 text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-emerald-500 outline-none";

  return (
    <div data-testid="registration-step" className="max-w-md mx-auto">
      <div className="text-center mb-8">
        <div className="w-14 h-14 bg-emerald-600 rounded-xl flex items-center justify-center mx-auto mb-4"><UserPlus className="w-7 h-7 text-white" /></div>
        <h2 className="text-2xl font-bold text-gray-900">Create Your Account</h2>
        <p className="text-gray-500 mt-2 text-sm">Register to submit your assessment and track its progress</p>
      </div>
      {error && <div data-testid="register-error" className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg mb-6 text-sm">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Full Name</label>
          <div className="relative"><User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input data-testid="register-name" type="text" value={form.full_name} onChange={e => setForm({ ...form, full_name: e.target.value })} className={inputCls} placeholder="Your full name" required /></div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Email</label>
          <div className="relative"><Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input data-testid="register-email" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className={inputCls} placeholder="your@email.com" required /></div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Company</label>
          <div className="relative"><Building className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input data-testid="register-company" type="text" value={form.company_name} onChange={e => setForm({ ...form, company_name: e.target.value })} className={inputCls} placeholder="Company name" /></div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Password</label>
          <div className="relative"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input data-testid="register-password" type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className={inputCls} placeholder="Min 6 characters" required /></div>
        </div>
        <button data-testid="register-submit-btn" type="submit" disabled={loading}
          className="w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 rounded-lg transition-colors disabled:opacity-50 mt-2">
          {loading ? 'Creating Account...' : 'Register & Submit Assessment'}</button>
      </form>
    </div>
  );
};

export default RegistrationStep;
